import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DocViewDto } from 'src/app/models/track/doc-view-dto';
import { DomSanitizer } from '@angular/platform-browser';
import { QuoteRenderingService } from 'src/app/services/search/quote-rendering.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-image-view',
  templateUrl: './image-view.component.html',
  styleUrls: ['./image-view.component.scss']
})
export class ImageViewComponent implements OnInit {

  content: DocViewDto;
  docDto: DocViewDto;
  image: any;

  constructor( 
    public dialogRef: MatDialogRef<ImageViewComponent>,
    @Inject(MAT_DIALOG_DATA) data: DocViewDto,
    private sanitizer: DomSanitizer,private qoutationService: QuoteRenderingService) {
    dialogRef.disableClose = true;
    this.content = data; 
   }

  ngOnInit() {
    this.docDto=this.qoutationService.docViewDto;
    let objectURL = 'data:image/'+this.docDto.documentType+';base64,' + this.docDto.document;
    this.image = this.sanitizer.bypassSecurityTrustUrl(objectURL);
  }

  close() {
    this.qoutationService.docViewDto=null;
    this.dialogRef.close(this.content);
  }

}
